 import api from "../../api.js";

export async function fetchInventoryCategories() {
  const res = await api.get("/api/inventory-categories");
  return res.data?.data || [];
}

export async function searchReceivedStock(type, query, department) {
  const res = await api.get("/api/receive-stock/search", {
    params: { type, query, department },
  });
  return res.data?.data ?? null;
}

export async function createReceivedStock(payload) {
  const res = await api.post("/api/receive-stock", payload);
  return res.data?.data ?? null;
}

export async function fetchStrengthOptions() {
  const res = await api.get("/api/strengths");
  return res.data?.data || [];
}

export async function fetchDosageFormOptions() {
  const res = await api.get("/api/dosageforms");
  return res.data?.data || [];
}
